import { NgModule } from '@angular/core';
import {NcMainContentComponent} from './nc-main-content/nc-main-content.component';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {FlexLayoutModule} from '@angular/flex-layout';



@NgModule({
  declarations: [NcMainContentComponent],
  imports: [
    ScrollingModule,
    FlexLayoutModule
  ],
  exports: [NcMainContentComponent]
})
export class NcMainContentModule { }
